import { render, staticRenderFns } from "./addUserInfo.vue?vue&type=template&id=2cb63c7a&scoped=true"
import script from "./addUserInfo.vue?vue&type=script&lang=js"
export * from "./addUserInfo.vue?vue&type=script&lang=js"
import style0 from "./addUserInfo.vue?vue&type=style&index=0&id=2cb63c7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2f37ed56e32c39bf37bd07aa5cbb5c73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb63c7a",
  null
  
)

export default component.exports